export const LocationIDConstant = {
    SET_LOCATION_ID: 'SET_LOCATION_ID',
    GET_LOCATION_ID: 'GET_LOCATION_ID'
};